import { TFunction } from '@sortlist-frontend/translation/ssr';

import { getLocalizedUrl } from '_core/utils/public-links/getLocalizedUrl';
import { AnchorType, Link, Links, Page, Person } from '_types/public-api';

export type LinkStoryDetails = {
  business: {
    name: string | undefined;
    type: string | undefined;
    description: string | undefined;
    projectType: string | undefined;
    projectBudget: number | undefined;
  };
  persons?: Person | undefined;
  videoUrl?: string | undefined;
  content: {
    descriptionTitle: string | undefined;
    paragraphs: {
      title: string | undefined;
      body: string | undefined;
    }[];
  };
  thumbnailUrl?: string | undefined;
  title?: string | undefined;
  subTitle?: string | undefined;
  tagline?: string | undefined;
};

export const getStoryInfo = (
  data: Page['data']['attributes'] | undefined,
  t: TFunction,
): LinkStoryDetails | undefined => {
  // Payload of storyPage can retrieve services depending on how many services the client/agencie has. We need to make this verification to avoid an error.
  const serviceType = data?.description.project?.services
    ? data?.description.project?.services?.[0].name
    : data?.description.project?.service?.[0].name;
  const personData = data?.description.persons?.[0];
  const businessesData = data?.description.businesses?.[0];

  if (data) {
    return {
      business: {
        name: businessesData?.name,
        type: businessesData?.type,
        description: businessesData?.description,
        projectType: serviceType,
        projectBudget: data.description.project?.budget.value,
      },
      persons: {
        firstName: personData?.firstName ? personData.firstName : '',
        lastName: personData?.firstName ? personData.lastName : '',
        jobTitle: personData?.firstName ? personData.jobTitle : '',
      },
      videoUrl: data.description.videoUrl,
      content: {
        descriptionTitle: data.description.descriptionTitle,
        paragraphs: data.description.paragraphs,
      },
      thumbnailUrl: data.description.imageUrl,
      title: data.title.title,
      subTitle: data.title.subtitle ? data.title.subtitle : t('story:header.subTitle', { name: businessesData?.name }),
      tagline: data.title.tagline ? data.title.tagline : t('story:header.text'),
    };
  }
};

export const numberWithDots = (number?: number) => {
  if (number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  return '';
};

export const getRelatedLink = (link: Link, links: Links): string => {
  if (link && links) {
    const findRelation = links?.included.find((page) => page.id === link.relationships.to_page.data.id);
    return getLocalizedUrl({ ...findRelation?.attributes, link: findRelation?.attributes.path } as AnchorType);
  } else {
    return '';
  }
};
